import { formats, locales } from '@lts-web/components/Calendar/config';

formats.merge({
    default: 'D/M/YYYY',
    engine: 'DD.MM.YY',
    deprecated: 'D-M-YYYY',
    deprecatedMobile: 'DD/MM/YY',
    processBar: 'DD MMMM YYYY',
    responseDates: 'DD-MM-YY',
    renderUiDates: 'DD/MM/YYYY',
    monthSelection: 'MM/YYYY',
    monthProcessBar: 'MMMM YYYY',
    renderUIMonths: 'MM/YYYY'
});

locales.merge({
    he: {
        days: ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"],
        daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        daysMin: ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש'],
        months: ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"],
        monthsShort: ["ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני", "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר"]
    }
});